import './mobileDecisionPageContent.scss';

import { LoadingSpinner, TransparentButton } from '@approvalmax/ui';
import { browserHelpers } from '@approvalmax/utils';
import { useSelector } from 'modules/react-redux';
import { AppleAppStore, GooglePlay } from 'modules/sprites';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import useMakeDecision from '../hooks/useMakeDecision';
import {
    OPERATION_RESULT_POPUP,
    OperationResultPopupData,
} from '../reducers/page/activePopup/operationResultPopupReducer';
import { getActivePopup, getActivePopupId } from '../selectors/pageSelectors';
import { downloadAndroidAppUrl, downloadIPhoneAppUrl } from './MobileDecisionPageContent.constants';
import { messages } from './MobileDecisionPageContent.messages';
import MobileOperationResultPanel from './MobileOperationResultPanel';

const bem = bemFactory.block('reql-mobile-page');

const MobileDecisionPageContent: FC = () => {
    const activePopupId = useSelector(getActivePopupId);
    const activePopup = useSelector<OperationResultPopupData>(getActivePopup);
    const operationResult = activePopupId === OPERATION_RESULT_POPUP ? activePopup.result : null;

    useMakeDecision(true);

    const downloadIPhoneApp = () => {
        window.location.href = downloadIPhoneAppUrl;
    };

    const downloadAndroidApp = () => {
        window.location.href = downloadAndroidAppUrl;
    };

    return (
        <div className={bem()}>
            {operationResult ? (
                <div className={bem('content')}>
                    <MobileOperationResultPanel className={bem('results-panel')} />

                    <div className={bem('footer')}>
                        <div className={bem('footer-text')}>{messages.mobileAppTipText}</div>

                        {browserHelpers.isIphone() ? (
                            <TransparentButton execute={downloadIPhoneApp} className={bem('download-button')}>
                                <AppleAppStore width={175} height={50} />
                            </TransparentButton>
                        ) : (
                            <TransparentButton execute={downloadAndroidApp} className={bem('download-button')}>
                                <GooglePlay width={175} height={50} />
                            </TransparentButton>
                        )}
                    </div>
                </div>
            ) : (
                <div className={bem('loading-panel')}>
                    <LoadingSpinner color='white' />
                </div>
            )}
        </div>
    );
};

export default memo(MobileDecisionPageContent);
